// Build a Google Calendar URL and an .ics file blob for a gathering.
// Dates are UTC in basic ISO (YYYYMMDDTHHMMSSZ) format.

const SITE = 'https://www.plantedministries.org';

export function googleCalUrl(event) {
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: `Planted Ministries — ${event.label}`,
    dates: `${event.startUtc}/${event.endUtc}`,
    details: `${event.label} · worship · Bible study. All are welcome.\n\n${event.dateLong} · ${event.time}\n${event.venue}\n${event.address}`,
    location: `${event.venue}, ${event.address}`,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

function escapeIcs(s) {
  return String(s || '')
    .replace(/\\/g, '\\\\')
    .replace(/\n/g, '\\n')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;');
}

export function buildIcs(event) {
  const now = new Date().toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  const uid = `${event.id}-plantedministries@local`;
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Planted Ministries//Launch Calendar//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${now}`,
    `DTSTART:${event.startUtc}`,
    `DTEND:${event.endUtc}`,
    `SUMMARY:${escapeIcs(`Planted Ministries — ${event.label}`)}`,
    `DESCRIPTION:${escapeIcs(`${event.label} · worship · Bible study. All are welcome.\n\n${event.dateLong} · ${event.time}\n${event.venue}\n${event.address}\n\n${SITE}`)}`,
    `LOCATION:${escapeIcs(`${event.venue}, ${event.address}`)}`,
    'STATUS:CONFIRMED',
    'TRANSP:OPAQUE',
    'BEGIN:VALARM',
    'TRIGGER:-PT30M',
    'ACTION:DISPLAY',
    'DESCRIPTION:Planted Ministries starts in 30 minutes',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');
}

// Try native share → fallback to download .ics
export async function addToCalendar(event) {
  const ics = buildIcs(event);
  const filename = `planted-${event.id}.ics`;
  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

// Detect iOS so we can prefer webcal/direct URL opening
export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}
